import type { SeoPlace, SeoText } from './interfaces';
import { PopularCountriesCard } from './PopularCountriesCard';

type PopularCountriesProps = {
    destination?: SeoPlace;
    countries: SeoPlace[];
    cdnUrl: string;
    verticalUrl: string;
    lang: SeoText;
};

export const PopularCountries = ({ destination, countries, cdnUrl, verticalUrl, lang }: PopularCountriesProps) => {
    const renderPopularCountriesCard = (dest: SeoPlace, idx: number) => (
        <PopularCountriesCard
            destination={dest}
            key={`countryCard${idx}`}
            id={`popCountry-${idx}`}
            cdnUrl={cdnUrl}
            verticalUrl={verticalUrl}
            lang={lang}
        />
    );

    const headingText = (): string =>
        destination
            ? lang.popularCountries.headingOther + (destination.continent ? ` i ${destination.continent}` : '')
            : lang.popularCountries.headingDefault;

    const descriptionText = (): string =>
        destination
            ? lang.popularCountries.descriptionOther
                  .replace(/\$continent/gm, destination.continent ?? '')
                  .replace(/\$destination/gm, destination.city ?? destination.country ?? '')
            : lang.popularCountries.descriptionDefault;

    return countries?.length > 1 ? (
        <section className="mb-32" aria-labelledby="seo-popular-country-title">
            <h3 id="seo-popular-country-title" className="px-16" data-testid="destination-countries-heading">
                {headingText()}
            </h3>
            <div className="mb-16 px-16" data-testid="destination-countries-description">
                {descriptionText()}
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3">{countries.map(renderPopularCountriesCard)}</div>
        </section>
    ) : null;
};
